"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _gridset = _interopRequireDefault(require("./gridset/gridset"));

var _griditem = _interopRequireDefault(require("./griditem/griditem"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries

/* ++++++++++ --------------- GRID : DEFINITION --------------- ++++++++++ */


var _default = {
  name: 'Grid',
  props: {
    children: {
      type: 'object',
      default: _react.default.createElement(_gridset.default, {
        direction: "vertical"
      }, _react.default.createElement(_griditem.default, null, "Item1"), _react.default.createElement(_griditem.default, null, "Item2"))
    }
  }
};
exports.default = _default;